import { createSelector } from 'reselect'

import { actionTypes } from 'actions/actionTypes'

export const getMenuLoadingErrorMessage = (state) => state.menu.get('menuLoadingErrorMessage')

export const isMenuLoading = createSelector(
  [
    (state) => state.boxSummaryShow.get('show'),
    (state) => state.menuBrowseCTAShow,
    (state) => state.pending.get(actionTypes.MENU_FETCH_DATA, false),
  ],
  (boxSummaryShow, menuBrowseCTAShow, menuLoading) => {
    const overlayShow = boxSummaryShow || menuBrowseCTAShow

    return menuLoading && !overlayShow
  },
)

export const getHasProspectNotSeenWizard = createSelector(
  [
    (state) => state.signup && state.signup.get('isInWizardFunnel'),
    (state) => state.auth && state.auth.get('isAuthenticated'),
  ],
  (isInWizardFunnel, isAuthenticated) => !isInWizardFunnel && !isAuthenticated,
)
